{
  "Activate Weave Payments": "Activate Weave Payments",
  "Beta": "Beta",
  "Bulk Collections": "Bulk Collections",
  "Continue Onboarding": "Continue Onboarding",
  "Dismiss": "Dismiss",
  "Enable Collections": "Enable Collections",
  "New": "New",
  "Send payment requests to multiple customers at once.": "Send payment requests to multiple customers at once.",
  "Start Collecting": "Start Collecting",
  "call-intel": {
    "Assign the <1>Data Analyst</1> role so staff can view insights and take action with AI-generated tasks. <4>Learn More</4>": "Assign the <1>Data Analyst</1> role so staff can view insights and take action with AI-generated tasks. <4>Learn More</4>",
    "Dismiss": "Dismiss",
    "Empower your team to act on insights": "Empower your team to act on insights",
    "Manage User Roles": "Manage User Roles",
    "Some analyzed calls are private and hidden from this table. <2>Learn More</2>": "Some analyzed calls are private and hidden from this table. <2>Learn More</2>",
    "Use the <1>Sync Summary</1>, button to manually upload the call summary to the patient record": "Use the <1>Sync Summary</1>, button to manually upload the call summary to the patient record",
    "Use the <1>Sync Summary</1>, button to manually upload the call summary to the patient record, or <3>automatic sync</3> in <6>Sync Settings</6>": "Use the <1>Sync Summary</1>, button to manually upload the call summary to the patient record, or <3>automatic sync</3> in <6>Sync Settings</6>"
  },
  "payments": {
    "63% of patients are more likely to pay quickly using Text-to-Pay.": "63% of patients are more likely to pay quickly using Text-to-Pay.",
    "83% of offices that use Weave Payments collect faster.": "83% of offices that use Weave Payments collect faster.",
    "Activate Weave Payments to send payment requests for {{pmsName}} balances to multiple patients at once.": "Activate Weave Payments to send payment requests for {{pmsName}} balances to multiple patients at once.",
    "Bulk Collections": "Bulk Collections",
    "CareCredit is now available in Weave. Give customers the option to pay for treatments while helping you collect payments faster.": "CareCredit is now available in Weave. Give customers the option to pay for treatments while helping you collect payments faster.",
    "Collapse": "Collapse",
    "Collect outstanding balances from {{pmsName}} all at once.": "Collect outstanding balances from {{pmsName}} all at once.",
    "Create Account": "Create Account",
    "Create a payment request": "Create a payment request",
    "Customers can easily pay online with Text-to-Pay and Online Bill Pay": "Customers can easily pay online with Text-to-Pay and Online Bill Pay",
    "Customers pay on time more often with Text-to-pay and Online Bill Pay": "Customers pay on time more often with Text-to-pay and Online Bill Pay",
    "Dismiss": "Dismiss",
    "Enable Collections to send payment requests to multiple patients at once with Bulk Collections.": "Enable Collections to send payment requests to multiple patients at once with Bulk Collections.",
    "Get Started": "Get Started",
    "Get free Online Bill Pay link": "Get free Online Bill Pay link",
    "Learn More": "Learn More",
    "Maybe Later": "Maybe Later",
    "Never show again": "Never show again",
    "Offer Flexible Financing with CareCredit": "Offer Flexible Financing with CareCredit",
    "Payments Balance": "Payments Balance",
    "Recent Appointments": "Recent Appointments",
    "Request Payment": "Request Payment",
    "Save over 2 hours per day using Weave Text-to-Pay.": "Save over 2 hours per day using Weave Text-to-Pay.",
    "Send Text-to-Pay link to customers": "Send Text-to-Pay link to customers",
    "Send payment requests to multiple patients at once with Bulk Collections.": "Send payment requests to multiple patients at once with Bulk Collections.",
    "Set Up Payments Account": "Set Up Payments Account",
    "Set up Payments to see patient balance here": "Set up Payments to see patient balance here",
    "Setup Payment Account": "Setup Payment Account",
    "Snooze for 3 days": "Snooze for 3 days",
    "You must set up a payments account first.": "You must set up a payments account first.",
    "Your plan includes Payments": "Your plan includes Payments",
    "You’ll need your Merchant ID Number and either your practice code or last 4 digits of your bank account number to get started.": "You’ll need your Merchant ID Number and either your practice code or last 4 digits of your bank account number to get started."
  },
  "true-lark": {
    "Get a Demo": "Get a Demo",
    "Maybe Later": "Maybe Later",
    "Never show again": "Never show again",
    "Remind me in 3 days": "Remind me in 3 days",
    "See how TrueLark can answer all your calls.": "See how TrueLark can answer all your calls.",
    "You missed <1>{{missedCallCount}} calls</1> last month._one": "You missed <1>{{missedCallCount}} call</1> last month.",
    "You missed <1>{{missedCallCount}} calls</1> last month._other": "You missed <1>{{missedCallCount}} calls</1> last month."
  }
}
